import { Button, Modal } from "react-bootstrap";

const SwitchOfStateBotModal = ({
    botIsActive,
    handleCloseModal,
    AutomaticAssignmentModal,
    handleClickSwitch,
}) => {
    return (
        <>
            <Modal
                show={AutomaticAssignmentModal}
                onHide={handleCloseModal}
                backdrop="static"
                keyboard={false}
                className="geo-permission-modal"
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{botIsActive ? "Desactivar" : "Activar"} el bot de asignación</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <h5>¿Está seguro que desea modificar la configuracion del bot?</h5>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Cancelar</Button>
                    <Button variant="primary" onClick={() => handleClickSwitch()}>Confirmar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SwitchOfStateBotModal;